import { FC, useEffect, useState } from "react";
import "./CategoryView.scss";
import MainNavbar from "../../../components/MainNavbar/MainNavbar";
import HeaderPage from "../../../components/HeaderPage/HeaderPage";
import { Col, Container, Row } from "react-bootstrap";
import BreadcrumbPage from "../../../components/BreadcrumbPage/BreadcrumbPage";
import { useArticles } from "../../../providers/Articles/ArticlesProvider";
import { useAgentsCategories } from "../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";
import { Link, useParams } from "react-router-dom";
import ListArticlesView from "../../../components/Articles/ListArticlesView/ListArticlesView";
import ScrollTopButton from "../../../components/ScrollTopButton/ScrollTopButton";

interface CategoryViewProps {}

const CategoryView: FC<CategoryViewProps> = () => {
  const [category, setCategory] = useState<any>(null);

  const { articlesStructure, handleListByStructure } = useArticles();
  const { categories, setParams } = useAgentsCategories();

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    id && setParams({ filter: { id }, withPaginate: false });
  }, [id]);

  useEffect(() => {
    if (id && categories.length > 0) {
      const _category = categories.find(c => String(c.id) === id || String(c.category_id) === id);
      if (_category) {
        handleListByStructure({ category_id: _category.id }, "category");
        setCategory(_category);
      }
    }
  }, [categories, id]);

  return (
    <>
      <MainNavbar />

      <div className="CategoryView" data-testid="CategoryView">
        <HeaderPage
          title={category?.name ?? ""}
          subtitle={category?.description ?? ""}
        />
        <div className="breadcrumb-wrapper">
          <Container>
            <Row className="justify-content-center">
              <Col md={10}>
                <BreadcrumbPage category={category} />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="content-wrapper">
          <Container>
            <Row className="justify-content-center py-sm-5 py-3">
              <Col md={10}>
                <ListArticlesView
                  articlesStructure={articlesStructure}
                  viewMode="category"
                />
              </Col>
            </Row>
          </Container>
        </div>
        <ScrollTopButton />
      </div>
    </>
  );
};

export default CategoryView;
